"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _isomorphicFetch = _interopRequireDefault(require("isomorphic-fetch"));
var _isNaN2 = _interopRequireDefault(require("lodash/isNaN"));
var _toNumber2 = _interopRequireDefault(require("lodash/toNumber"));
var _isNumber2 = _interopRequireDefault(require("lodash/isNumber"));
var _cuid2 = _interopRequireDefault(require("cuid"));
var _uid2 = _interopRequireDefault(require("uid"));
var _memoize = require('lodash/memoize');
var _assign = require('lodash/assign');
var Common = {
  toQueryString: function toQueryString(obj) {
    return encodeURI(Object.keys(obj).map(function (k) {
      return "".concat(k, "=").concat(obj[k]);
    }).join('&'));
  },
  callApi: _memoize(/*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(key, opt) {
      var options, queryString, fetchPromise, timeoutPromise, response, data, _t;
      return _regenerator["default"].wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            options = _assign({
              method: 'GET',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
              }
            }, opt);
            if (typeof options.data !== 'string') {
              options.body = JSON.stringify(options.data);
            }
            queryString = options.params ? "?".concat(Common.toQueryString(options.params)) : '';
            fetchPromise = (0, _isomorphicFetch["default"])("".concat(Entry.baseUrl || '').concat(options.url).concat(queryString), options);
            timeoutPromise = new Promise(function (_, reject) {
              return setTimeout(function () {
                return reject(new Error('Request timeout'));
              }, 3000);
            });
            _context.prev = 1;
            _context.next = 2;
            return Promise.race([fetchPromise, timeoutPromise]);
          case 2:
            response = _context.sent;
            if (!(response.status >= 400)) {
              _context.next = 3;
              break;
            }
            Common.callApi.cache = new _memoize.Cache();
            throw new Error(response);
          case 3:
            _context.next = 4;
            return response.json();
          case 4:
            data = _context.sent;
            return _context.abrupt("return", {
              data: data
            });
          case 5:
            _context.prev = 5;
            _t = _context["catch"](1);
            Common.callApi.cache = new _memoize.Cache();
            throw _t;
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 5]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }()),
  toNumber: function toNumber(str) {
    if (typeof str === 'number') {
      return str;
    }
    if (Array.isArray(str)) {
      return str.map(function (x) {
        return Common.toNumber(x);
      });
    }
    if (!(0, _isNaN2["default"])(parseInt(str, 10)) && !(0, _isNaN2["default"])((0, _toNumber2["default"])(str))) {
      return (0, _toNumber2["default"])(str);
    }
    return str;
  },
  generateId: function generateId() {
    return (0, _uid2["default"])(8) + (0, _cuid2["default"])();
  }
};
module.exports = Common;